import "./infoForOlds.scss";
import React from "react";

const WHATSAPP_URL = "https://chat.whatsapp.com/Hq4VIYOPR5aLM4UWmQyZD2";

const InfoForOlds = () => {
  return (
    <section className="dolgoletie info-block" aria-labelledby="dolgoletie-heading">
      <div className="info-container">
        <h2 id="dolgoletie-heading" className="info-block__title">
          Бесплатные занятия по бильярду
        </h2>
        <p className="info-block__subtitle">
          для участников проекта{" "}
          <span className="dolgoletie">«Московское долголетие»</span>
        </p>

        <p className="info-block__loc">
          Москва, ул. Мусы Джалиля, 4, корп. 6 — бильярдный клуб «ЛИГА»
        </p>

        <p className="highlight">
          Чтобы записаться на занятия, перейдите по ссылке и вступите в группу
          WhatsApp.
        </p>

        <p>
          <a
            className="info-block__wa"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
          >
            Присоединиться в WhatsApp
          </a>
        </p>

        <div className="info-block__schedule">
          <p className="info-block__schedule-title">Занятия проводятся:</p>
          <p>
            Понедельник — четверг
            <br />
            09:30 — 13:45
          </p>
        </div>

        <p className="info-block__note">
          Опытные инструкторы помогут освоить навыки игры в бильярд, подберут кий,
          объяснят правила и технику ударов — спокойный темп и поддерживающая
          атмосфера.
        </p>
      </div>
    </section>
  );
};

export default InfoForOlds;
